import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {SearchComponent} from "./pages/search/search.component";
import {ViewComponent} from "./pages/view/view.component";

const routes: Routes = [
  {
    path: "",
    component: SearchComponent
  },
  {
    path: ":trackingCode",
    component: ViewComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
